import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profile: {
    id: null,
    firstName: "",
    lastName: "",
    mobileNumber: "",
    isMobileVerified: false,
    emailId: "",
    isEmailIdVerified: false,
    isLocked: false,
    lockedUntil: null,
    isActive: true,
    providerTypes: [],
    services: [],
    addresses: [],
  },
  business: {
    id: null,
    service_provider_id: null,
    business_name: "",
    short_description: "",
    long_description: "",
    upi_image_id: "",
    upi_id: "",
    createdAt: null,
    updatedAt: null,
    upiImage: {
      id: "",
      file_name: "",
      file_type: "",
      storage_path: "",
      description: null,
      created_by: "",
      created_by_type: "",
      is_linked: false,
      createdAt: null,
      updatedAt: null,
    },
    galleryImages: [],
  },
};

const providerProfileSlice = createSlice({
  name: "providerProfile",
  initialState,
  reducers: {
    setBusinessData: () => {},
    resetProviderProfile: () => {},
    setProfileData: (state, action) => {
      const payload = action.payload;
      console.log("setProfileData=> ");
      console.log(payload);
      state.profile = {
        id: payload.id ?? null,
        firstName: payload.firstName ?? "",
        lastName: payload.lastName ?? "",
        mobileNumber: payload.mobileNumber ?? "",
        isMobileVerified: payload.isMobileVerified ?? false,
        emailId: payload.emailId ?? "",
        isEmailIdVerified: payload.isEmailIdVerified ?? false,
        isLocked: payload.isLocked ?? false,
        lockedUntil: payload.lockedUntil ?? null,
        isActive: payload.isActive ?? false,
        providerTypes: Array.isArray(payload.providerTypes)
          ? payload.providerTypes
          : [],
        services: Array.isArray(payload.services) ? payload.services : [],
        addresses: Array.isArray(payload.addresses) ? payload.addresses : [],
      };
    },

    setBusinessData: (state, action) => {
      const payload = action.payload;

      state.business = {
        id: payload.id ?? null,
        service_provider_id: payload.service_provider_id ?? null,
        business_name: payload.business_name ?? "",
        short_description: payload.short_description ?? "",
        long_description: payload.long_description ?? "",
        upi_image_id: payload.upi_image_id ?? "",
        upi_id: payload.upi_id ?? "",
        createdAt: payload.createdAt ?? null,
        updatedAt: payload.updatedAt ?? null,
        upiImage: {
          id: payload.upiImage?.id ?? "",
          file_name: payload.upiImage?.file_name ?? "",
          file_type: payload.upiImage?.file_type ?? "",
          storage_path: payload.upiImage?.storage_path ?? "",
          description: payload.upiImage?.description ?? null,
          created_by: payload.upiImage?.created_by ?? "",
          created_by_type: payload.upiImage?.created_by_type ?? "",
          is_linked: payload.upiImage?.is_linked ?? false,
          createdAt: payload.upiImage?.createdAt ?? null,
          updatedAt: payload.upiImage?.updatedAt ?? null,
        },
        galleryImages: Array.isArray(payload.galleryImages)
          ? payload.galleryImages.map((img) => ({
              id: img.id ?? "",
              file_name: img.file_name ?? "",
              file_type: img.file_type ?? "",
              storage_path: img.storage_path ?? "",
              description: img.description ?? null,
              created_by: img.created_by ?? "",
              created_by_type: img.created_by_type ?? "",
              is_linked: img.is_linked ?? false,
              createdAt: img.createdAt ?? null,
              updatedAt: img.updatedAt ?? null,
            }))
          : [],
      };
    },

    resetProviderProfile: (state) => {
      state.profile = initialState.profile;
      state.business = initialState.business;
    },
  },
});

export const { setProfileData, setBusinessData, resetProviderProfile } =
  providerProfileSlice.actions;
export default providerProfileSlice.reducer;
